import { UserService } from '@/api/types';

export function isUserService(obj: unknown): obj is UserService {
  if (typeof obj !== 'object' || obj === null) return false;

  const service = obj as Record<string, any>;

  const allowedTypes: Record<keyof UserService, Array<Nullable<string>>> = {
    id: ['string'],
    name: ['string'],
    type: ['string'],
    source: ['object', null],
    categories: ['object'],
    link: ['string', null],
    icon: ['string', null],
    code: ['string', null],
    withAuth: ['boolean'],
    documentName: ['string', null],
    video_instruction: ['string', 'undefined'],
    isAvailable: ['boolean'],
    paymentType: ['string'],
    btn_cta: ['string', null],
    faq: ['object', null],
    captcha_is_enabled: ['boolean'],
    is_hidden: ['boolean'],
    sync_profile_available: ['boolean'],
  };

  for (const [key, allowed] of Object.entries(allowedTypes)) {
    const value = service[key];
    const valueType = value === null ? null : typeof value;

    if (!allowed.includes(valueType)) return false;
  }

  return true;
}
